import React from "react";
import GameCardLayout from "../layout/GameCardLayout";
import FilledButton from "./FilledButton";
import { IoClose } from "react-icons/io5";
import ScoreCard from "./ScoreCard";
import StatusCard from "./StatusCard";
import WordTriesCard from "./WordTriesCard";
const CryptoHuntFailedCard = ({
  totalAttempt,
  timeTaken,
  wordTries,
  totalPoints,
  correctWord,
  handleTryNext,
  handleClose,
  className,
}) => {
  const getAttemptCount = (attempt) => {
    if (attempt === 0) return "1st Attempt";
    else if (attempt === 1) return "2nd Attempt";
    else return "3rd Attempt";
  };
  return (
    <div className="w-full h-full flex 2xl:-mt-10 xl:-mt-12 lg:-mt-16 justify-center ">
      <GameCardLayout
        className={`w-[440px] relative  ${className}`}
        text="Your attempts are admirable. Try your left attempts"
        title="Admirable Attempt!"
      >
        <IoClose
          onClick={handleClose}
          className="text-3xl text-[#888] transition-all duration-150 ease hover:text-[#555] active:scale-[0.90] cursor-pointer absolute sm:top-10 top-6 sm:right-8 right-5"
        />
        <div className="w-full  mt-4 flex flex-col items-start relative">
          <h1 className="xs:text-[13px] text-xs font-medium">Status</h1>
          <div className="flex xs:mt-2 mt-1 flex-row xs:gap-x-3 gap-x-1 w-full items-center">
            <StatusCard title="Total Attempts" value={totalAttempt} />
            <StatusCard title="Time Taken" value={`${timeTaken} Sec`} />
          </div>
          <h1 className="text-[13px] mt-3 font-medium">Word tries</h1>
          <WordTriesCard
            className="mt-2"
            wordTries={wordTries}
            getAttemptCount={getAttemptCount}
          />
          <h1 className="xs:text-[13px] text-xs mt-3 font-medium">
            Score Breakdown
          </h1>
          <div className="mt-2 border-[0.8px] border-[#434343] w-full rounded-xl flex flex-col gap-y-1 px-4 py-3 text-[11px] bg-[#0e0e0e]">
            <ScoreCard title="Total Points" value={totalPoints} />
            <ScoreCard title="Points" value={0} />
          </div>
          <div className="flex flex-row w-full mt-2 px-4 py-3 border-[0.8px] border-[#434343] bg-[#0e0e0e] rounded-xl text-[14px] justify-between">
            <p className="">Correct Word</p>
            <span className="text-[#08e43b] font-bold uppercase">
              {correctWord}
            </span>
          </div>
          <div className="flex flex-row w-full sm:mt-4 xs:mt-3 mt-2 px-2 xs:text-xl text-base font-bold justify-between">
            <p className="">Final Points</p>
            <span className="text-[08e43b]">0 pts</span>
          </div>
          <div className="mt-2 w-full  flex justify-center items-center">
            <button
              onClick={handleTryNext}
              style={{
                boxShadow:
                  "0 6px 12px -8px #fff inset,0 -12px 15px 0px rgba(255,255,255,0.4) inset, 0 0 10px rgba(255,255,255,0.3) inset",
              }}
              className=" px-11 py-2 transition-all duration-150 ease hover:opacity-90 active:scale-[0.96] bg-radial-play rounded-full text-white text-[14px] font-semibold"
            >
              Try Next
            </button>
          </div>
        </div>
      </GameCardLayout>
    </div>
  );
};

export default CryptoHuntFailedCard;
